// extracted by mini-css-extract-plugin
module.exports = {"CategoryItem_main":"CategoryTitle2_CategoryItem_main__Wb_bA","CategoryItem_main_info":"CategoryTitle2_CategoryItem_main_info__1vXwJ"};